import type { SVGProps } from "react";
const SvgIconCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="M384.72 748.13a23.92 23.92 0 0 1-17-7L198 571.4a24 24 0 0 1 34-33.94l152.72 152.73L792 282.9a24 24 0 0 1 34 33.94L401.69 741.1a23.92 23.92 0 0 1-16.97 7.03" />
  </svg>
);
export default SvgIconCheck;
